export { PlaceholderMenuImageBanner, PlaceholderCategoriesNav } from './placeholder-content';
